export default __webpack_public_path__ + "static/GT-America-Extended-Bold-172443a1dc243a9cdc81fdffc43ddbc3.woff2";